import React from "react";
import { Table, Input, Button } from "reactstrap";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";

const detailingData = [
  { brand: "Cover Page (Elena)", P1: "60.02", P2: "0.03", P3: "0", P4: "0" },
  { brand: "Isoft", P1: "608.43", P2: "1,639.35", P3: "3.68", P4: "0.30" },
  { brand: "Isoft SR", P1: "0.03", P2: "23.13", P3: "161.48", P4: "0" },
  {
    brand: "Crina Ncr",
    P1: "118.32",
    P2: "150.70",
    P3: "264.58",
    P4: "640.85",
  },
  {
    brand: "Vehycal Xt",
    P1: "111.35",
    P2: "144.88",
    P3: "110.82",
    P4: "205.90",
  },
  { brand: "New Vehycal", P1: "0", P2: "35.28", P3: "23.27", P4: "20.23" },
  { brand: "Lactonic", P1: "0", P2: "0", P3: "7.72", P4: "52.53" },
];

const DetailingHeatMap = () => {
  return (
    <div
    
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 style={{fontWeight: "600" }}>
          Detailing Heat Map (In Min)
        </h5>
        <div className="d-flex gap-2">
        <RoundedDropdown
            options={[]}
            onSelect={(e: any) => {
              console.log(e);
            }}
            defaultLabel="All Specialities"
            width="auto"
            headingColor="#2e8dd3"
            DropdownHeading=''
            backgroundColor='success'
          />
        <RoundedDropdown
            options={[]}
            onSelect={(e: any) => {
              console.log(e);
            }}
            defaultLabel="All Specialities"
            width="auto"
            headingColor="#2e8dd3"
            DropdownHeading=''
            backgroundColor='success'
          />
        </div>
      </div>
      <Table bordered responsive style={{ backgroundColor: "white" }}>
        <thead style={{ backgroundColor: "#ECF7F9" }}>
          <tr>
            <th style={{ color: "#4E87BC" }}>Brand Name</th>
            <th style={{ color: "#4E87BC" }}>P1</th>
            <th style={{ color: "#4E87BC" }}>P2</th>
            <th style={{ color: "#4E87BC" }}>P3</th>
            <th style={{ color: "#4E87BC" }}>P4</th>
          </tr>
        </thead>
        <tbody>
          {detailingData.map((item, index) => (
            <tr key={index} style={{ color: "#000", fontWeight: 600 }}>
              <td>{item.brand}</td>
              <td>{item.P1}</td>
              <td>{item.P2}</td>
              <td>{item.P3}</td>
              <td>{item.P4}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DetailingHeatMap;
